import AccountsList from '../../../../../components/Accounts/List/AccountsList';
import i18next from 'i18next';
import AccountsLogo from '../../../../../components/Shared/Icons/AccountsLogo';
import permissions from '../../../../permissions';
import AccountCreate from '../../../../../components/Accounts/Item/AccountCreate';
import AccountEdit from '../../../../../components/Accounts/Item/AccountEdit';
import DashboardLogo from '../../../../../components/Shared/Icons/DashboardLogo';
import PatientUpload from '../../../../../components/Uploads/PatientUpload/PationtUpload';
import InsuranceUpload from '../../../../../components/Uploads/InsuranceUpload/InsuranceUpload';
import ClaimsUpload from '../../../../../components/Uploads/ClaimsUpload/ClaimsUpload';
import ProvidersUpload from '../../../../../components/Uploads/ProvidersUpload/ProvidersUpload';

const ACCOUNT_ROUTE_LIST_DS = {
  path: '/:currentAccountUuid/accounts',
  exact: true,
  additional: {
    component: AccountsList,
    protected: true,
    title: i18next.t('titles:accounts'),
    icon: AccountsLogo,
    permission: permissions.ACCOUNTS_GET,
  },
};

const ACCOUNT_ROUTE_CREATE_DS = {
  path: '/:currentAccountUuid/accounts/create',
  exact: true,
  parentRoute: ACCOUNT_ROUTE_LIST_DS,
  additional: {
    component: AccountCreate,
    protected: true,
    title: i18next.t('titles:createAccount'),
  },
};

const ACCOUNT_ROUTE_EDIT_DS = {
  path: '/:currentAccountUuid/accounts/:accountUuid/edit',
  exact: true,
  parentRoute: ACCOUNT_ROUTE_LIST_DS,
  additional: {
    component: AccountEdit,
    protected: true,
    title: i18next.t('titles:editAccount'),
  },
};

const ACCOUNT_ROUTE_PATIENT_UPLOAD = {
  path: '/:currentAccountUuid/accounts/:accountUuid/patientUpload',
  exact: true,
  parentRoute: ACCOUNT_ROUTE_LIST_DS,
  additional: {
    component: PatientUpload,
    title: i18next.t('titles:patientUpload'),
    protected: true,
    icon: DashboardLogo,
    permission: permissions.ADMIN_PATIENT_IMPORT,
  },
};

const ACCOUNT_ROUTE_INSURANCE_UPLOAD = {
  path: '/:currentAccountUuid/accounts/:accountUuid/insuranceUpload',
  exact: true,
  parentRoute: ACCOUNT_ROUTE_LIST_DS,
  additional: {
    component: InsuranceUpload,
    title: i18next.t('titles:insuranceUpload'),
    protected: true,
    icon: DashboardLogo,
    permission: permissions.ADMIN_PATIENT_IMPORT,
  },
};

const ACCOUNT_ROUTE_CLAIMS_UPLOAD = {
  path: '/:currentAccountUuid/accounts/:accountUuid/claimsUpload',
  exact: true,
  parentRoute: ACCOUNT_ROUTE_LIST_DS,
  additional: {
    component: ClaimsUpload,
    title: i18next.t('titles:claimsUpload'),
    protected: true,
    icon: DashboardLogo,
    permission: permissions.ADMIN_PATIENT_IMPORT,
  },
};

const ACCOUNT_ROUTE_PROVIDERS_UPLOAD = {
  path: '/:currentAccountUuid/accounts/:accountUuid/providersUpload',
  exact: true,
  parentRoute: ACCOUNT_ROUTE_LIST_DS,
  additional: {
    component: ProvidersUpload,
    title: i18next.t('titles:providersUpload'),
    protected: true,
    icon: DashboardLogo,
    permission: permissions.ADMIN_PATIENT_IMPORT,
  },
};

const ACCOUNT_ROUTE_EDIT = {
  path: '/:currentAccountUuid/edit',
  exact: true,
  additional: {
    component: AccountEdit,
    protected: true,
    title: i18next.t('titles:editAccount'),
  },
};

export const ACCOUNT_ROUTES = {
  // ------- For child accounts ------
  listDS: ACCOUNT_ROUTE_LIST_DS,
  createDS: ACCOUNT_ROUTE_CREATE_DS,
  editDS: ACCOUNT_ROUTE_EDIT_DS,
  patientUpload: ACCOUNT_ROUTE_PATIENT_UPLOAD,
  insuranceUpload: ACCOUNT_ROUTE_INSURANCE_UPLOAD,
  claimsUpload: ACCOUNT_ROUTE_CLAIMS_UPLOAD,
  providersUpload: ACCOUNT_ROUTE_PROVIDERS_UPLOAD,

  // ------- For current accounts ------
  edit: ACCOUNT_ROUTE_EDIT,
};
